export const FETCH_EMAIL_TEMPLATE = "FETCH_EMAIL_TEMPLATE";
export const CREATE_EMAIL_TEMPLATE = "CREATE_EMAIL_TEMPLATE";
export const UPDATE_EMAIL_TEMPLATE = "UPDATE_EMAIL_TEMPLATE";
export const DELETE_EMAIL_TEMPLATE = "DELETE_EMAIL_TEMPLATE";